<template>
  <div id="services">
    <sectionImage section="services" :text="header" :summary="summary" />
    <b-container>
    <!--  <sectionSummary :text="summary" /> -->
      <serviceTemplate ref="consulting" :data="consulting" service="consulting"/>
    </b-container>

    <div class="gis">
      <b-container>
        <serviceTemplate ref="gis" :data="gis" service="gis"/>
      </b-container>
    </div>

    <b-container>
      <serviceTemplate ref="bi" :data="bi" service="bi"/>
      <img src="./assets/bi21.jpg" />
    </b-container>
  </div>
</template>

<script>
import sectionImage from '../SectionImage'
import sectionSummary from '../text/SectionSummary'
import serviceTemplate from './Service'

const SECTIONID = 5

export default {
  name: 'services',
  props: {
    section: {
      type: String,
      default: 'none'
    },
    language: {
      type: String
    }
  },
  components: {
    sectionImage,
    sectionSummary,
    serviceTemplate
  },
  data () {
    return {
      header: '',
      summary: '',
      consulting: {
        header: '',
        summary: '',
        listHeader: '',
        list: []
      },
      gis: {
        header: '',
        summary: '',
        listHeader: '',
        list: []
      },
      bi: {
        header: '',
        summary: '',
        listHeader: '',
        list: []
      }
    }
  },
  watch: {
    section: function () {
      this.scrollTo()
    },
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  mounted: function () {
    this.scrollTo()
  },
  methods: {
    handleLanguage: function () {
      this.header = this.$root.getHeader(SECTIONID)
      this.summary = this.$root.getSummary(SECTIONID)
      this.consulting = {
        header: this.$root.getCategoryHeader(SECTIONID, 0),
        summary: this.$root.getCategorySummary(SECTIONID, 0),
        listHeader: this.$root.getCategoryListHeader(SECTIONID, 0),
        list: this.$root.getCategoryList(SECTIONID, 0)
      }
      this.gis = {
        header: this.$root.getCategoryHeader(SECTIONID, 1),
        summary: this.$root.getCategorySummary(SECTIONID, 1),
        listHeader: this.$root.getCategoryListHeader(SECTIONID, 1),
        list: this.$root.getCategoryList(SECTIONID, 1)
      }
      this.bi = {
        header: this.$root.getCategoryHeader(SECTIONID, 2),
        summary: this.$root.getCategorySummary(SECTIONID, 2),
        listHeader: this.$root.getCategoryListHeader(SECTIONID, 2),
        list: this.$root.getCategoryList(SECTIONID, 2)
      }
    },
    scrollTo: function () {
      var navbarHeight = 50
      switch (this.section.toLowerCase()) {
        case 'consulting':
          this.$refs.consulting.$el.scrollIntoView()
          let scrolledY = window.scrollY
          window.scroll(0, scrolledY - navbarHeight)
          break
        case 'gis':
          this.$refs.gis.$el.scrollIntoView()
          scrolledY = window.scrollY
          window.scroll(0, scrolledY - navbarHeight)
          break
        case 'bi':
          this.$refs.bi.$el.scrollIntoView()
          scrolledY = window.scrollY
          window.scroll(0, scrolledY - navbarHeight)
          break
        default:
          this.$el.scrollIntoView()
          break
      }
    }
  }
}

</script>

<style scoped>

.summary {
  text-align: center;
}

.gis {
  background: url('./assets/map.jpg') no-repeat 70% 50%;
  background-size: cover;
}

img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 600px;
    height: auto;
    margin-bottom: 20px;
}

@media only screen and (max-width: 768px) {
  img {
      width: 100%;
      height: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/services/Services.vue